import { AxiosResponse } from 'axios';
import { SimilarByPatternSettingsTypes } from '../types';

export const similarByPatternSettingsResponse = ({
  data,
}: AxiosResponse): SimilarByPatternSettingsTypes.SimilarByPatternSettings => {
  return {
    numberOfResultsToDisplay: data.numberOfResultsToDisplay,
  };
};
